@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';

.ciHeader-account-subMenu {
  display: block;
  max-height: 0;
  opacity: 0;
  padding: 0;
  border: 0;
  overflow: hidden;
  transition: all 200ms;
  &--isActive {
    display: block;
    max-height: 20rem;
    opacity: 1;
    overflow: visible;
  }
  &--isSignedIn {
    .ciHeader-account-subMenu--signedOutMenu {
      display: none;
    }
    .ciHeader-account-subMenu--signedInMenu {
      display: block;
    }
  }
  position: absolute;
  right: 0;
  // must be below the z-index of 101, set for the .ciHeader-accounts-btn element in default-header.scss
  z-index: 100;
  background: transparent;
  font-size: .875rem;
  a[data-link="sign in"],
  a[data-link="sign up"] {
    font-family: SharpSans, Sharp Sans, Helvetica, Arial, "Trebuchet MS", sans-serif;
    border-radius: 6px;
    height: 48px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    border: none;
    gap: $spacing-8;
    padding: 0 $spacing-16;
    font-size: $typography-button-large-size;
    line-height: $typography-line-height;
  }
  a[data-link="sign in"]{
    margin-bottom: .5rem;
    border: 1px solid $color-blue-default;
    background: $color-blue-default;
    color: $color-shade-white;
    &:link, &:visited {
      color: $color-shade-white;
    }
    &:hover {
      background: $color-blue-hover;
      border: 1px solid $color-blue-hover;
    }
  }
  a[data-link="sign up"] {
    border: 1px solid $color-blue-default;
    color: $color-blue-default;

    &:hover {
      background-color: $color-blue-hover;
      color: $color-shade-white;
    }
  }

  &-content {
    display: block;
    background: white;
    box-shadow: 0 6px 12px 0px rgba(0,0,0,0.11);
    border-top: 0;
    border-radius: .5rem;
    overflow: hidden;
  }
  &--signedOutMenu {
    display: block;
    box-sizing: border-box;
    width: 308px;
    color: $color-gray-slate-default;
    padding: 1rem;
  }
  &--signedInMenu {
    display: none;
    width: 284px;
    box-sizing: border-box;
    padding:.5rem 0;
    a {
      display: flex;
      height:2.25rem;
      padding:0rem .5rem;
      margin:0 .5rem;
      align-items: center;
      gap:.5rem;
      align-self: stretch;
      border-radius: 0.25rem;
      line-height: 1.285;
      color: $color-gray-slate-default;
      text-decoration: none;
      &:link, &:visited {
        color: $color-gray-slate-default;
      }
      &:hover {
        color: $color-blue-default;
        background: $color-header-hover-blue;
        svg path {
          fill: $color-blue-default;
        }
      }
      &:focus {
        border-radius: 4px;
        border: 1px solid $color-blue-default;
      }
      img {
        height: 1rem;
        width: auto;
      }
    }
  }
  // signed out styles
  &-title {
    font-weight: bold;
    display: block;
    font-size: 1.25rem;
    margin-bottom: .5rem;
    color: $color-gray-slate-default;
  }
  &-subtitle {
    display: block;
    padding-bottom: 1rem;
    color: $color-gray-slate-default;
  }
  // signed in styles
  &-icon {
    display: inline-block;
    svg {
      height: 17.93px;
      width: 16.25px;
      padding:1.67px 2.5px 0.4px 1.25px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  &-icon, &-linkText {
    vertical-align: middle;
  }
  &-last {
    margin-bottom: .5rem;
  }
  hr {
    display: block;
    border: 0;
    border-bottom: 1px solid #E3E3E3;
    margin: 0.5rem 0;
  }
  &-logout {
    margin-top: .5rem;
    margin-bottom: .5rem;
  }
}
